import { Box } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Swap } from '@factorialco/f0-react/icons/app'

import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'
import LabeledInput from 'modules/core/components/LabeledInput'
import MoneyField from 'modules/core/components/MoneyField'
import i18n from 'modules/core/lib/i18n'

interface IRatesSingleForm {
  areJobLevelRates?: boolean
  billRate: string
  currency: string
  disabledAllFields?: boolean
  errors: {
    billRate?: string
    minProfitMargin?: string
  }
  maxCostRate: string
  minProfitMargin: string
  handleBillRateChange: (value: string) => void
  handleProfitMarginChange: (value: string) => void
}
const RatesSingleForm = ({
  areJobLevelRates = false,
  billRate,
  currency,
  disabledAllFields = false,
  errors,
  maxCostRate,
  minProfitMargin,
  handleBillRateChange,
  handleProfitMarginChange,
}: IRatesSingleForm) => {
  const costRateLabel = areJobLevelRates
    ? {
        label: i18n.t('project_management.jobs_and_rates.sidepanels.form.max_cost_rate.label'),
        tooltip: i18n.t(
          'project_management.jobs_and_rates.sidepanels.form.max_cost_rate.tooltip_message'
        ),
      }
    : {
        label: i18n.t('project_management.people_and_rates.form.cost_rate.label'),
        tooltip: i18n.t('project_management.people_and_rates.form.cost_rate.tooltip_message'),
      }
  const profitMarginLabel = areJobLevelRates
    ? {
        label: i18n.t('project_management.jobs_and_rates.sidepanels.form.min_profit_margin.label'),
        tooltip: i18n.t(
          'project_management.jobs_and_rates.sidepanels.form.min_profit_margin.tooltip_message'
        ),
      }
    : {
        label: i18n.t('project_management.people_and_rates.form.profit_margin.label'),
        tooltip: i18n.t('project_management.people_and_rates.form.profit_margin.tooltip_message'),
      }

  const billRateLabel = areJobLevelRates
    ? {
        label: i18n.t('project_management.jobs_and_rates.sidepanels.form.bill_rate.label'),
        tooltip: i18n.t(
          'project_management.jobs_and_rates.sidepanels.form.bill_rate.tooltip_message_for_job'
        ),
      }
    : {
        label: i18n.t('project_management.people_and_rates.form.bill_rate.label'),
        tooltip: i18n.t('project_management.people_and_rates.form.bill_rate.tooltip_message'),
      }

  return (
    <>
      <Box flexDirection="row" gap="s8">
        <LabeledInput
          isLegend
          label={costRateLabel.label}
          secondaryLabel={<InformationTooltip information={costRateLabel.tooltip} />}
        >
          <></>
        </LabeledInput>
        <LabeledInput
          isLegend
          label={billRateLabel.label}
          secondaryLabel={<InformationTooltip information={billRateLabel.tooltip} />}
        >
          <></>
        </LabeledInput>
        <Box paddingRight="s20" />
        <LabeledInput
          isLegend
          label={profitMarginLabel.label}
          secondaryLabel={<InformationTooltip information={profitMarginLabel.tooltip} />}
        >
          <></>
        </LabeledInput>
      </Box>
      <Box flexDirection="row" gap="s8">
        <MoneyField
          hideLabel
          readonly
          label={costRateLabel.label}
          value={maxCostRate}
          currency={currency}
          maxDecimals={2}
          placeholder="0"
        />
        <MoneyField
          hideLabel
          readonly={disabledAllFields}
          label={billRateLabel.label}
          value={billRate}
          currency={currency}
          onChange={handleBillRateChange}
          error={errors.billRate}
          maxDecimals={2}
          placeholder="0"
        />
        <F0Icon icon={Swap} />
        <MoneyField
          hideLabel
          readonly={disabledAllFields}
          label={profitMarginLabel.label}
          value={minProfitMargin}
          currency="%"
          onChange={handleProfitMarginChange}
          maxDecimals={2}
          placeholder="0"
        />
      </Box>
    </>
  )
}

export default RatesSingleForm
